import { render, staticRenderFns } from "./ClvrScreenControlOperatingRoomStaff.vue?vue&type=template&id=142dfdf1"
import script from "./ClvrScreenControlOperatingRoomStaff.ts?vue&type=script&lang=ts&external"
export * from "./ClvrScreenControlOperatingRoomStaff.ts?vue&type=script&lang=ts&external"
import style0 from "./ClvrScreenControlOperatingRoomStaff.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports